"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionHistory = exports.ConnectionEvent = exports.ConnectionState = exports.DatapointHistory = exports.DatapointHistoryItem = exports.LatestData = exports.DatapointInsertPayload = void 0;
const effect_1 = require("effect");
const Azure = __importStar(require("../../../../../../azure"));
const Json = __importStar(require("../../../../../../json"));
const field_1 = require("../../../../openapi/field");
const NAMESPACE = 'Culligan.Api.V1.Admin.Device.Schema';
exports.DatapointInsertPayload = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    property: effect_1.Schema.propertySignature(effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/))).annotations({
        description: 'Top-level JavaScript identifier; dotted paths are not accepted',
    }),
    value: effect_1.Schema.propertySignature(Json.Value),
    source: effect_1.Schema.optionalWith(effect_1.Schema.Literal('state', 'telemetry'), { exact: true }).annotations({
        description: 'History source; defaults to telemetry and does not select the latest-data destination bucket',
    }),
}).annotations({
    identifier: `${NAMESPACE}.DatapointInsertPayload`,
});
exports.LatestData = effect_1.Schema.Struct({
    datapoints: Json.Record,
    lastUpdate: effect_1.Schema.NullOr((0, field_1.dateTime)('ISO-8601 last datapoint time')),
}).annotations({
    identifier: `${NAMESPACE}.LatestData`,
});
exports.DatapointHistoryItem = effect_1.Schema.Struct({
    timestamp: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        description: 'Stored record creation time; legacy records may use a non-ISO SQL-style timestamp',
    }),
})
    .pipe(effect_1.Schema.extend(effect_1.Schema.Record({
    key: effect_1.Schema.String,
    value: effect_1.Schema.NullOr(Json.Value),
})))
    .annotations({
    identifier: `${NAMESPACE}.DatapointHistoryItem`,
    description: 'Requested property values plus timestamp; absent values are null',
});
exports.DatapointHistory = effect_1.Schema.Struct({
    datapoints: effect_1.Schema.Array(exports.DatapointHistoryItem),
    pagination: effect_1.Schema.Struct({
        page: effect_1.Schema.Int.pipe(effect_1.Schema.positive()),
        pages: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
        total: effect_1.Schema.Int.pipe(effect_1.Schema.nonNegative()),
    }),
}).annotations({
    identifier: `${NAMESPACE}.DatapointHistory`,
});
exports.ConnectionState = effect_1.Schema.Struct({
    serialNumber: (0, field_1.nonEmpty)('Device serial number'),
    connected: effect_1.Schema.Boolean,
    lastHeartbeatTime: effect_1.Schema.NullOr((0, field_1.dateTime)('Latest Azure IoT Hub activity time')),
}).annotations({
    identifier: `${NAMESPACE}.ConnectionState`,
});
const ConnectionEventCommon = {
    id: (0, field_1.nonEmpty)('Connection-history record id'),
    region: Azure.MacroRegion,
    createdAt: (0, field_1.dateTime)('Connection event time'),
};
exports.ConnectionEvent = effect_1.Schema.Union(effect_1.Schema.Struct({
    ...ConnectionEventCommon,
    online: effect_1.Schema.Literal(true),
    source: effect_1.Schema.optionalWith(effect_1.Schema.Literal('data', 'event'), { exact: true }),
}), effect_1.Schema.Struct({
    ...ConnectionEventCommon,
    online: effect_1.Schema.Literal(false),
    source: effect_1.Schema.optionalWith(effect_1.Schema.Literal('timeout', 'event'), { exact: true }),
})).annotations({
    identifier: `${NAMESPACE}.ConnectionEvent`,
    description: 'Connection event with deviceId removed by the v1 admin controller',
});
exports.ConnectionHistory = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.ConnectionEvent),
}).annotations({
    identifier: `${NAMESPACE}.ConnectionHistory`,
});
//# sourceMappingURL=schema.js.map